<template>
    <i class="o-icon" :class="className">
        <svg :class="`svg-${icon}`">
            <title v-if="title">{{ title }}</title>
            <use v-bind:xlink:href="path"></use>
        </svg>
    </i>
</template>

<script>
export default {
    name: "Icon",
    props: {
        icon: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: ""
        }
    },
    computed: {
        path() {
            let icon = require(`@/assets/svg/sources/${this.icon}.svg`);
            if (Object.prototype.hasOwnProperty.call(icon, "default")) {
                icon = icon.default;
            }

            return icon.url;
        },
        className() {
            let name = `-${this.icon}`;
            name = this.size ? `${name} -${this.size}` : name;
            return name;
        }
    }
};
</script>

<style lang="scss">
/*=============================
=            Icons            =
=============================*/

.o-icon {
    display: inline-block;
    vertical-align: middle;

    svg {
        display: block;
        fill: currentColor;
    }

    &.-xl {
        font-size: 4em;
    }
}

/*=================================
=            SVG Sizes            =
=================================*/

// Arrows
.svg-arrow-up,
.svg-arrow-down {
    width: 1.31em;
    height: 1.23em;
}

.svg-arrow-left,
.svg-arrow-right {
    width: 1.23em;
    height: 1.31em;
}

.svg-arrow-up-left,
.svg-arrow-up-right {
    width: 1em;
    height: 1em;
}

// Download
.svg-download {
    width: 1.61em;
    height: 1.25em;
}

// Socials
.svg-facebook {
    width: 1.25rem;
    height: 1.25rem;
}

.svg-instagram {
    width: 1.25rem;
    height: 1.25rem;
}

// Partners
.svg-chantier-economie-sociale {
    width: 11em;
    height: 3.81em;
}

.svg-poles-economie-sociale {
    // width: 4em;
    // height: 0.8em;
    width: 100%;
    aspect-ratio: 4/0.8;
    object-fit: contain;
    object-position: center;
    fill: currentColor;
}

/*
// Graph icons
[class^="svg-graph-"] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.o-icon.-graph-bsl          { @include padding-hack(158, 120, 100%); }
.o-icon.-graph-centre       { @include padding-hack(150, 162, 100%); }
.o-icon.-graph-cesim        { @include padding-hack(216, 138, 100%); }
.o-icon.-graph-cn           { @include padding-hack(153, 178, 100%); }
.o-icon.-graph-cotenord     { @include padding-hack(175, 175, 100%); }
.o-icon.-graph-cri          { @include padding-hack(128, 155, 100%); }
.o-icon.-graph-espaceec     { @include padding-hack(268, 164, 100%); }
.o-icon.-graph-essor02      { @include padding-hack(150, 160, 100%); }
.o-icon.-graph-estrie       { @include padding-hack(122, 164, 100%); }
.o-icon.-graph-jamesien     { @include padding-hack(186, 186, 100%); }
.o-icon.-graph-lanaudiere   { @include padding-hack(156, 118, 100%); }
.o-icon.-graph-laurentides  { @include padding-hack(172, 172, 100%); }
.o-icon.-graph-laval        { @include padding-hack(132, 132, 100%); }
.o-icon.-graph-longueuil    { @include padding-hack(173, 108, 100%); }
.o-icon.-graph-madelaine    { @include padding-hack(138, 205, 100%); }
.o-icon.-graph-mauricie     { @include padding-hack(198, 218, 100%); }
.o-icon.-graph-monteregie   { @include padding-hack(190, 170, 100%); }
.o-icon.-graph-nunavik      { @include padding-hack(170, 230, 100%); }
.o-icon.-graph-outaouais    { @include padding-hack(122, 164, 100%); }
.o-icon.-graph-pn           { @include padding-hack(132, 132, 100%); }
.o-icon.-graph-tresca       { @include padding-hack(155, 161, 100%); }
.o-icon.-graph-vhsl         { @include padding-hack(178, 130, 100%); }

.o-icon.-graph-house        { @include padding-hack(48, 65, 100%); }
.o-icon.-graph-serve        { @include padding-hack(96, 63, 100%); }
*/
</style>
